import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import "../../Styles/TenanatDashBoard.scss";
import Images from "../../Assets/Images";
import { Link, NavLink } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { Popup } from "@progress/kendo-react-popup";
import { ColorPicker } from "@progress/kendo-react-inputs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import Api from "../../Services/Api";
import { CircularProgress } from "@material-ui/core";
import { toastr } from "react-redux-toastr";

export default class TenantDashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      editFlag: false,
      scope: "1",
      openCreateDashboard: false,
      colorCode: "",
    };
  }

  componentDidMount() {
    this.getDashboard();
  }
  getDashboard = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getDashboard(request);
      
      if (response.status == 200 && response.dashBoardResponse) {
        this.setState({
          ...this.state,
          loader: false,
          dashBoardResponse: response.dashBoardResponse,
        });
        
      } else {
        this.setState({
          ...this.state,
          loader: false,
          dashBoardResponse: { publicDashboard: [], privateDashboard: [] },
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  CreateDashboardOpen = () => {
      this.setState({
      openCreateDashboard: true,
     });
  };

  CreateDashboardClose = () => {
       this.setState({
      ...this.state,
      openCreateDashboard: false,
      editFlag: false,
    });
  };
  deleteDashBoard = (item) => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: true,
      dashBoardId: item.dashBoardId,
    });
  };

  deleteDashboardPopupClose = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
      dashBoardId: null,
    });
  };
  removeDashboard = async () => {
    try {
      const requestParams = {
        DeletedBy: this.state.dashBoardId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteDashboard(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.deleteDashboardPopupClose();
        this.getDashboard();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  editDashBoard = (item) => {
    this.setState({
      ...this.state,
      editFlag: true,
      name: item.name,
      colorCode: item.colorCode,
      scope: item.scope.toString(),
      dashBoardId: item.dashBoardId,
      createdby:item.createdby
    });
    this.CreateDashboardOpen();
  };
  saveDashboard = async () => {
    if (!this.state.name) {
      return;
    }
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        Name: this.state.name,
        Scope: parseInt(this.state.scope),
        ColorCode: this.state.colorCode.value,
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.saveDashboard(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.CreateDashboardClose();
        this.getDashboard();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  updateDashboard = async () => {
    if (!this.state.name) {
      return;
    }
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        Name: this.state.name,
        Scope: parseInt(this.state.scope),
        ColorCode: this.state.colorCode.value,
        // CreatedBy: parseInt(this.state.createdby),
        UpdatedBy: parseInt(createdby),
        DashBoardId:this.state.dashBoardId
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.updateDashboard(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.CreateDashboardClose();
        this.getDashboard();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  navigateToReport=(row) =>{
    const token =
        secureLocalStorage.getItem("loggedClient") == "user"
          ? secureLocalStorage.getItem("userKey")
          : secureLocalStorage.getItem("tenantKey");
const loggedClient = secureLocalStorage.getItem("loggedClient");

    this.props.history.push({
      pathname: `/${loggedClient}/${token}/home/dashboard/reports/${row.dashBoardId}`,
    });
  }
  render() {
    return (
      <div className="appCont">
        <div className="mainWrapper">
          <div className="dashboardCont">
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <Popup
              show={this.state.openDeleteModelFlag}
              popupClass={"popup-content"}
            >
              {this.state.loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}
              <div className="deleteModelCont">
                <h3>Are you sure? You want to delete this Dashboard.</h3>
                <div className="btnCont">
                  <button
                    onClick={() => this.removeDashboard()}
                    className="deleteBtn"
                  >
                    Delete
                  </button>
                  <button
                    onClick={this.deleteDashboardPopupClose}
                    className="cancelBtn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Popup>

            <Popup
              show={this.state.openCreateDashboard}
              popupClass={"popup-content"}
            >
              <form name="dashboardname">
                <div className="createDashboardDialog">
                  {this.state.loader ? (
                    <span className="MatTableSpinner">
                      <CircularProgress
                        style={{ color: "#FFFFFF" }}
                        size={70}
                      />
                    </span>
                  ) : null}
                  <h4>Create Dashboard</h4>
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-10">
                      <div className="formControl">
                        <label>Dashboard name</label>
                        <input
                          type="text"
                          value={this.state.name}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              name: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-2">
                      <div className="formControl colorpicker">
                        <label>Color</label>
                        {/* <input type="color" /> */}
                        <ColorPicker
                          view="gradient"
                          defaultValue={this.state.colorCode}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              colorCode: e,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="accessSpecifier">
                    <RadioGroup
                      aria-label="gender"
                      name="gender1"
                      value={this.state.scope}
                      onChange={(e) =>
                        this.setState({
                          ...this.state,
                          scope: e.target.value,
                        })
                      }
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Public"
                      />
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="Private"
                      />
                    </RadioGroup>
                  </div>
                  <div className="btnCont">
                    {this.state.editFlag ? (
                      <button
                        className="btnGreen"
                        type="button"
                        onClick={this.updateDashboard}
                      >
                        Update Dashboard
                      </button>
                    ) : (
                      <button
                        className="btnGreen"
                        type="button"
                        onClick={this.saveDashboard}
                      >
                        Save Dashboard
                      </button>
                    )}

                    <button
                      className="btnRed"
                      type="button"
                      onClick={this.CreateDashboardClose}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </Popup>
            <div className="dbGrids">
              <div className="dbRow">
                <div className="dbCol ddCol lBox">
                  <div className="gBox dbConfig">
                    <div className="iconBox">
                      <img
                        src={Images.DASHBOARDICON}
                        width="16"
                        alt="Dashboard"
                      />
                    </div>
                    <div className="dbConfigData">
                      <h4>Dashboards</h4>
                    </div>
                    <div className="ml-auto configBtn">
                      <button onClick={this.CreateDashboardOpen}>
                        Create Dashboard
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="ddListCont">
              <h4>Public Dashboards</h4>
              <ul>
                {this.state.dashBoardResponse &&
                  this.state.dashBoardResponse.publicDashboard.map((item1) => (
                    <li>
                      <ul>
                        <li>
                        <a
                        title="Delete"
                        className="redbtn icon"
                        onClick={() => this.deleteDashBoard(item1)}
                      >
                        <img src={Images.DELETE} width="10" alt="Cancel" />
                      </a>
                        </li>
                        <li>
                        <a
                        title="Delete"
                        className="redbtn icon"
                        onClick={() => this.editDashBoard(item1)}
                      >
                        <img src={Images.EDITICON} width="10" alt="Cancel" />
                      </a>
                        </li>
                      </ul>
                       
                     
                      <a
                        className="gbox"
                        style={{
                          border: "1px solid rgba(53,62,193,0.5)",
                          background: item1.colorCode,
                        }}
                        onClick={()=>this.navigateToReport(item1)}
                      >
                        
                        <b>{item1.name}</b>
                      </a>
                    </li>
                  ))}
              </ul>
            </div>

            <div className="ddListCont">
              <h4>Private Dashboards</h4>
              <ul>
                {this.state.dashBoardResponse &&
                  this.state.dashBoardResponse.privateDashboard.map((item) => (
                    <li>
                      <ul>
                        <li>
                        <a
                        title="Delete"
                        className="redbtn icon"
                        onClick={() => this.deleteDashBoard(item)}
                      >
                        <img src={Images.DELETE} width="10" alt="Cancel" />
                      </a>
                        </li>
                        <li>
                        <a
                        title="Delete"
                        className="redbtn icon"
                        onClick={() => this.editDashBoard(item)}
                      >
                        <img src={Images.EDITICON} width="10" alt="Cancel" />
                      </a>
                        </li>
                      </ul>
                      
                      
                      <a
                        className="gbox"
                        style={{
                          border: "1px solid rgba(177,162,27,0.5)",
                          background: item.colorCode,
                        }}
                      >
                       <b>{item.name}</b> 
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
